import {Injectable, Renderer2, RendererFactory2, SecurityContext} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  public static default_theme = 'theme-light';
  private static THEME_KEY = 'theme';
  private readonly styleTheme: HTMLLinkElement;
  private _customCss:string|undefined;
  constructor(protected sanitizer: DomSanitizer) {
    this.styleTheme = this.crateStylesheet(this.currentTheme, ThemeService.THEME_KEY);
    if (ThemeService.default_theme === this.currentTheme){
      this.appendCustomCss();
    } else {
      this.removeCustomCss('custom-theme');
    }
  }

  public get currentTheme(): string {
    return localStorage.getItem(ThemeService.THEME_KEY) ?? ThemeService.default_theme;
  }

  public set currentTheme(value: string) {
    localStorage.setItem(ThemeService.THEME_KEY, value);

    this.styleTheme.href = `/${value}.css`;
    if (ThemeService.default_theme === this.currentTheme){
      this.appendCustomCss();
    } else {
      this.removeCustomCss('custom-theme');
    }
  }

  set customCss(value: string | undefined) {
    this._customCss = value;
    this.appendCustomCss();
  }

  private crateStylesheet(themename: string, key: string) {
    const styleElement = document.createElement('link');
    styleElement.rel = 'stylesheet';
    document.head.appendChild(styleElement);

    if (localStorage.getItem(key) !== undefined) {
      styleElement.href = `/${themename}.css`;
    }
    return styleElement;
  }

  createStyle(id:string, styleName: string) {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.id = id;
    style.type = 'text/css';


    let textStyle = this.sanitizer.sanitize(SecurityContext.STYLE, styleName)
    if (textStyle == null){
      return;
    }
    style.appendChild(
      document.createTextNode(textStyle)
    );
    head.appendChild(style);
  }

  appendCustomCss() {
    if (this._customCss === undefined){
      return
    }
    this.createStyle('custom-theme', this._customCss)
  }

  removeCustomCss(id: string) {
    const head = document.getElementsByTagName('head')[0];
    let sheet = document.getElementById(id);
    if (sheet === null){
      return;
    }
    head.removeChild(sheet);
  }
}
